import { GraduationCap } from 'lucide-react';
import { COURSES } from '@/lib/learning/courses';
import { useLearningProgress } from '@/hooks/useLearningProgress';
import { CourseCard } from './components/CourseCard';
import { LearningProgressBar } from './components/LearningProgressBar';

const TOTAL_LESSONS = COURSES.reduce((sum, c) => sum + c.lessonCount, 0);

/**
 * Page hub du Centre d'apprentissage — grille des 9 parcours avec progression globale.
 */
export default function LearningHubPage() {
  const { completedCountForCourse, totalCompleted, isLoading } = useLearningProgress();

  return (
    <div className="mx-auto max-w-5xl px-6 py-8">
      {/* Header */}
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-2">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-blue-50 dark:bg-blue-900/30">
            <GraduationCap className="w-5 h-5 text-blue-600 dark:text-blue-400" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-slate-900 dark:text-white">
              Centre d'apprentissage
            </h1>
            <p className="text-sm text-slate-500 dark:text-slate-400">
              Maitrisez le growth marketing et les outils Feedback Orchestrator
            </p>
          </div>
        </div>

        {/* Global progress */}
        {!isLoading && (
          <div className="mt-4 max-w-md">
            <p className="mb-1.5 text-xs font-medium text-slate-500 dark:text-slate-400">
              Progression globale
            </p>
            <LearningProgressBar completed={totalCompleted} total={TOTAL_LESSONS} />
          </div>
        )}
      </div>

      {/* Courses grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {COURSES.map((course) => (
          <CourseCard
            key={course.slug}
            course={course}
            completedCount={completedCountForCourse(course.slug)}
          />
        ))}
      </div>
    </div>
  );
}
